
import Schema, { required, optional } from 'AppReact/schema';
import { file } from 'types';

const popup = {
  text: required('string'),
  position: optional('string')
};

export default {
  files: Schema(file, 'array', { defaultValue: [] }),
  alignLeft: Schema('boolean', 'primitive', { defaultValue: false }),
  popup: Schema(popup, 'object', { defaultValue: { text: '' } })
}